<!-- Assets leadership content -->

<!-- Magazine Design -->
<ng-container *ngIf="selectedDesign === 'magazine'">
  <fieldset class="leadership-provider-fieldset leadership-category-assets">
    <legend class="leadership-provider-fieldset--legend">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display: inline-block; vertical-align: middle; margin-right: 8px;">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="9" y1="3" x2="9" y2="21"></line>
        <line x1="3" y1="9" x2="21" y2="9"></line>
      </svg>
      Assets Leaderboard
    </legend>
    
    <div class="magazine-design">
      <!-- Featured Leader (Position 1 only) -->
      <div class="magazine-featured animate-fade-in" *ngIf="topThree[0]">
        <!-- Background Assets Icons -->
        <div class="featured-background-icon featured-background-icon-1">
          <svg width="100" height="100" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M48 42.6667L58.6667 32L48 21.3334" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.9999 21.3334L5.33325 32L15.9999 42.6667" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M38.6666 10.6666L25.3333 53.3333" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="featured-background-icon featured-background-icon-2">
          <svg width="100" height="100" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M53.3333 37.3333C56.2789 37.3333 58.6667 34.9455 58.6667 32C58.6667 29.0544 56.2789 26.6666 53.3333 26.6666C50.3878 26.6666 48 29.0544 48 32C48 34.9455 50.3878 37.3333 53.3333 37.3333Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M53.3333 16C56.2789 16 58.6667 13.6122 58.6667 10.6667C58.6667 7.72119 56.2789 5.33337 53.3333 5.33337C50.3878 5.33337 48 7.72119 48 10.6667C48 13.6122 50.3878 16 53.3333 16Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M53.3333 58.6667C56.2789 58.6667 58.6667 56.2789 58.6667 53.3333C58.6667 50.3878 56.2789 48 53.3333 48C50.3878 48 48 50.3878 48 53.3333C48 56.2789 50.3878 58.6667 53.3333 58.6667Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.6666 37.3333C13.6121 37.3333 15.9999 34.9455 15.9999 32C15.9999 29.0544 13.6121 26.6666 10.6666 26.6666C7.72107 26.6666 5.33325 29.0544 5.33325 32C5.33325 34.9455 7.72107 37.3333 10.6666 37.3333Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 32H48" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M47.9999 10.6666H37.3333C31.9999 10.6666 29.3333 13.3333 29.3333 18.6666V45.3333C29.3333 50.6666 31.9999 53.3333 37.3333 53.3333H47.9999" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="featured-background-icon featured-background-icon-3">
          <svg width="100" height="100" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M53.3333 8H39.9999C38.5272 8 37.3333 9.19391 37.3333 10.6667V24C37.3333 25.4728 38.5272 26.6667 39.9999 26.6667H53.3333C54.806 26.6667 55.9999 25.4728 55.9999 24V10.6667C55.9999 9.19391 54.806 8 53.3333 8Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M26.6667 56V21.3333C26.6667 20.626 26.3857 19.9478 25.8856 19.4477C25.3855 18.9476 24.7072 18.6666 24 18.6666H10.6667C9.95942 18.6666 9.28115 18.9476 8.78105 19.4477C8.28095 19.9478 8 20.626 8 21.3333V53.3333C8 54.0405 8.28095 54.7188 8.78105 55.2189C9.28115 55.719 9.95942 56 10.6667 56H42.6667C43.3739 56 44.0522 55.719 44.5523 55.2189C45.0524 54.7188 45.3333 54.0405 45.3333 53.3333V40C45.3333 39.2927 45.0524 38.6144 44.5523 38.1143C44.0522 37.6142 43.3739 37.3333 42.6667 37.3333H8" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="featured-main-grid">
          <div class="featured-col-9">
            <span class="featured-badge-top">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
              </svg>
              #1 TOP LEADER
            </span>
            <div class="featured-name-section">
              <div class="featured-name-text">
                <div class="featured-name-row-inline">
                  <h2 class="featured-name">{{ topThree[0].name }}</h2>
                  <div class="featured-crown">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                      <path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z" fill="#FFD700" stroke="#FFA500" stroke-width="1.5"/>
                      <circle cx="12" cy="12" r="2" fill="#FFA500"/>
                    </svg>
                  </div>
                </div>
                <p class="featured-role"><span class="role-label">Published By</span> <span class="role-value">{{ topThree[0].organizationName || topThree[0].role }}</span></p>
              </div>
            </div>
          </div>
          <div class="featured-col-3">
            <div class="featured-scores featured-scores--grid" *ngIf="topThree[0].assetType || topThree[0].likes || topThree[0].downloads || topThree[0].views">
              <!-- Asset Type - Horizontal Layout -->
              <div class="featured-score featured-score--inline featured-score--horizontal" *ngIf="topThree[0].assetType">
                <span class="score-metric">
                  <img [src]="getAssetTypeIcon(topThree[0].assetType)" [alt]="topThree[0].assetType" class="score-icon" *ngIf="getAssetTypeIcon(topThree[0].assetType)" />
                  <span class="asset-type-label">{{ topThree[0].assetType.toUpperCase() }}</span>
                </span>
              </div>
              <div class="featured-score featured-score--inline">
                <span class="score-label">UPVOTES</span>
                <span class="score-metric">
                  <svg class="score-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11a2 2 0 0 0 2-2l1-7a2 2 0 0 0-2-2h-5z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                    <path d="M7 22H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span class="score-value">{{ topThree[0].likes ?? 0 }}</span>
                </span>
              </div>
              <div class="featured-score featured-score--inline">
                <span class="score-label">DOWNLOADS</span>
                <span class="score-metric">
                  <svg class="score-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 3v10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5 21h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span class="score-value">{{ topThree[0].downloads ?? 0 }}</span>
                </span>
              </div>
              <div class="featured-score featured-score--inline">
                <span class="score-label">VIEWS</span>
                <span class="score-metric">
                  <svg class="score-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <span class="score-value">{{ topThree[0].views ?? 0 }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Other Leaders - Minimal Style -->
      <div class="minimal-list-wrapper">
        <div class="minimal-list">
          <div class="minimal-item animate-fade-in" *ngFor="let member of leadershipMembers.slice(1); let i = index" [style.animation-delay]="(i * 0.1 + 0.2) + 's'">
            <div class="minimal-details">
              <div class="minimal-name-row-inline">
                <h3 class="minimal-name">{{ member.name }}</h3>
                <div class="minimal-crown" *ngIf="member.rank === 2 || member.rank === 3" [class.crown-silver]="member.rank === 2" [class.crown-bronze]="member.rank === 3">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                    <path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z" [attr.fill]="member.rank === 2 ? '#C0C0C0' : '#CD7F32'" [attr.stroke]="member.rank === 2 ? '#808080' : '#8B4513'" stroke-width="1.5"/>
                    <circle cx="12" cy="12" r="2" [attr.fill]="member.rank === 2 ? '#808080' : '#8B4513'"/>
                  </svg>
                </div>
                <div class="minimal-rank-badge minimal-rank-star" *ngIf="member.rank > 3">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="star-icon">
                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
                  </svg>
                  <span class="star-rank-number">{{ member.rank }}</span>
                </div>
              </div>
              <p class="minimal-role"><span class="role-label">Published By</span> <span class="role-value">{{ member.organizationName || member.role }}</span></p>
            </div>
            <div class="minimal-scores" *ngIf="member.assetType || member.likes || member.downloads || member.views">
              <!-- Asset Type - Horizontal Layout -->
              <div class="minimal-score-card minimal-score-card--horizontal" *ngIf="member.assetType">
                <span class="score-metric">
                  <img [src]="getAssetTypeIcon(member.assetType)" [alt]="member.assetType" class="score-icon" *ngIf="getAssetTypeIcon(member.assetType)" />
                  <span class="asset-type-label">{{ member.assetType.toUpperCase() }}</span>
                </span>
              </div>
              <div class="minimal-score-card">
                <span class="score-label">UPVOTES</span>
                <span class="score-metric">
                  <svg class="score-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11a2 2 0 0 0 2-2l1-7a2 2 0 0 0-2-2h-5z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                    <path d="M7 22H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span class="score-value">{{ member.likes ?? 0 }}</span>
                </span>
              </div>
              <div class="minimal-score-card">
                <span class="score-label">DOWNLOADS</span>
                <span class="score-metric">
                  <svg class="score-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 3v10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5 21h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span class="score-value">{{ member.downloads ?? 0 }}</span>
                </span>
              </div>
              <div class="minimal-score-card">
                <span class="score-label">VIEWS</span>
                <span class="score-metric">
                  <svg class="score-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <span class="score-value">{{ member.views ?? 0 }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Load More Button -->
      <div class="load-more-container" *ngIf="leadershipMembers.length >= 10">
        <button 
          class="load-more-button" 
          (click)="loadMoreAssets()"
          [disabled]="!assetsPagination.hasNext || assetsPagination.isLoading">
          <span *ngIf="!assetsPagination.isLoading">Load More</span>
          <span *ngIf="assetsPagination.isLoading">Loading more assets...</span>
        </button>
      </div>
    </div>
  </fieldset>
</ng-container>
